import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const escalationImporterSelectors = importerSelectors(
  'escalation.importer',
);

export default escalationImporterSelectors;
